import PDP from '@/scripts/libs/pdp'
import { Product } from '@/types/pdp'
import { FeaturedProductsCarouselHelper } from '@/scripts/libs/featured-products-carousel'
import { PlpProduct } from '@/types/plp'
import { normalizeFeaturedProduct } from '@/scripts/normalizer'

class WcsFeaturedProductsCarousel implements FeaturedProductsCarouselHelper {
  async fetchFeaturedProducts({
    catalogEntries,
    fetchAndAddProductAvailability,
  }: {
    catalogEntries?: string
    fetchAndAddProductAvailability: (_catEntryId: string) => void
  }): Promise<PlpProduct[]> {
    const catEntryIds = catalogEntries?.split(',')?.filter((item) => item !== '')
    if (!catEntryIds) {
      return []
    }
    const allPromises = catEntryIds.map((catEntryId) => {
      // eslint-disable-next-line no-async-promise-executor
      const promise = new Promise<Product>(async (resolve) => {
        const product = await PDP.fetchPDPDataFromService(+catEntryId)
        await fetchAndAddProductAvailability(catEntryId)
        if (product) {
          resolve(product)
        }
      })
      return promise
    })

    const correlatedProducts = await Promise.all(allPromises)

    const products = correlatedProducts
      .filter((product) => product && product?.catEntryId)
      .sort((a, b) => {
        if (!a || !b) {
          return 0
        }
        return catEntryIds.indexOf(a.catEntryId) - catEntryIds.indexOf(b.catEntryId)
      })

    return products.map((product) => normalizeFeaturedProduct(product))
  }
}

export default new WcsFeaturedProductsCarousel()
